import { cloud, three, data } from "xx-packages";

// import Preloader from "./Preloader"
import device from "./Device";

import "./index.css";

/* globals preloader */

const { cloudClient } = cloud;
const { AppSingle } = three;
const { queryStringToObject } = data.conversion;

// const preloader = new Preloader()

const preloader = window.preloader;

const params = queryStringToObject(window.location.search);

/* DEFAULT CONSTANTS - OBSOLATE ******************************************/

const inputManConf = {
  mkb: {
    enabled: true,
    channels: {
      ui: {
        enabled: false,
        count: 2,
      },
    },
  },
  touch: {
    enabled: false,
  },
  gamepad: {
    enabled: false,
  },
  midi: {
    enabled: !!params.forwardMIDI,
  },
  network: {
    enabled: false,
    p2pBrokerUrl: "wss://vjycloud.herokuapp.com/p2p/",
    peerId: params.peerId,
    connection: {
      peerId: params.remotePeerId,
      retryIntervalSeconds: 10,
      maxRetries: 5,
      forwardMIDI: params.forwardMIDI,
    },
  },
};

const appDecl = {
  settings: {
    cloud: {
      //includeMeta: false
      loadThumbnails: false,
    },

    inputMan: inputManConf,

    audioMan: {
      musicMeta: {},
    },
  },

  ui: {
    main: null,
    sys: {
      enabled: false,
      visible: false,
    },
  },

  project: {
    doAddHTML: true,
    doAddCSS: true,
    doScroll: false,
    allowSceneHTML: true,
    override: {},
    n: "Acuario",
  },
  dominantContext: "composition",
};

if (window?._params?.compId) {
  params.compId = window._params.compId;
}
if (window?._params?.project) {
  params.project = window._params.project;
}
if (window?._params?.compOverrideSettings) {
  params.compOverrideSettings = window._params.compOverrideSettings;
  appDecl.compOverrideSettings = window._params.compOverrideSettings;
}
if (window?._params?.doAddHTML !== undefined) {
  appDecl.project.doAddHTML = window?._params?.doAddHTML;
}
if (window?._params?.doAddCSS !== undefined) {
  appDecl.project.doAddCSS = window?._params?.doAddCSS;
}
if (window?._params?.doScroll !== undefined) {
  appDecl.project.doScroll = window?._params?.doScroll;
}

if (!document.getElementById("canvas")) {
  const canvas = document.createElement("canvas");
  canvas.id = "canvas";
  document.body.insertBefore(canvas, document.querySelector("#content"));
}

async function startApp() {
  let config = window._config;

  // run locally
  if (!config) {
    try {
      const res = await fetch(process.env.PUBLIC_URL + "/config.json");
      config = await res.json();
    } catch (err) {
      console.warn(
        "Error fetching config at: " + process.env.PUBLIC_URL + "/config.json",
        err
      );
    }
  }

  if (!config) throw new Error("No config found");

  // cloudClient.init({
  //   apiBaseUrl: config.cloud.apiBaseUrl,
  //   storage: window.localStorage,
  //   settings: appDecl.settings.cloud,
  //   cloudName: config.cloud.cloudName,
  //   // cloudBaseUrl: '/',
  // });

  // build step
  let cloudBaseUrl = "./";

  if (window?._params?.cloudBaseUrl)
    cloudBaseUrl = window?._params?.cloudBaseUrl;

  cloudClient.init({
    apiBaseUrl: "", //config.cloud.apiBaseUrl,
    storage: window.localStorage,
    settings: appDecl.settings.cloud,
    cloudBaseUrl,
  });

  const user = await cloudClient.getCurrentUser();

  if (!device.hasWebGL && preloader.showUnsupportedMessage) {
    return preloader.showUnsupportedMessage();
  }

  if (params.assetId) {
    appDecl.asset = { ">link": { id: params.assetId } };
    appDecl.project.override = {
      scene: {
        startComp: { ">link": { id: params.assetId } },
      },
    };
  } else if (params.compId) {
    appDecl.asset = { ">link": { id: params.compId } };
    appDecl.project.override = {
      scene: {
        startComp: { ">link": { id: params.compId } },
      },
    };
  }

  if (params.project) {
    if (params.project == "View.AV") {
      appDecl.project.id = user.settings.viewAV[">link"].id;
    } else {
      appDecl.project.n = params.project;
    }
  } else appDecl.project.id = user.settings.view[">link"].id;

  const app = new AppSingle(appDecl);
  app.preloader = preloader;
  app.device = device;
  app.enableScreenshot = false;
  app.scene.enableScreenshot = false;

  app.start();
}

startApp();
